<template>
    <div>
        <div class="box-title flex-between">
            <div class="box-title-text box-title-bg02">
                <p class="">借款人婚姻状况</p>
            </div>
            <div class="box-title-right">
            </div>
        </div>
        <div id="echart04" class="chart04" :style="{height: '280px'}"></div>
    </div>
</template>

<script>

    import xhr from "../../../utils/xhr";

    export default {
        name: 'MonitorEchartsFour',
        data() {
            return {
                nowDate: "",
                financingByMartialStatusList: []
            }
        },
        computed: {

        },
        mounted() {
            this.getFinancingByMartialStatusList();
        },
        methods:{
            echart04(){
                let myChart = this.$echarts.init(document.getElementById('echart04'))
                myChart.setOption({
                    // color: ['#3f8cf8','#11baa8','#e8d745','#e88c45'],
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)',
                        textStyle:{
                            fontSize:24,
                            color:'#96dcff'
                        }
                    },
                    legend: {
                        orient: 'vertical',
                        right: '15%',
                        top: '20%',
                        data: this.financingByMartialStatusList.map(item=>item.fi__martialStatus),
                        textStyle:{
                            fontSize:24,
                            color:'#96dcff'
                        },
                    },
                    series: [
                        {
                            name: '抵押物性质',
                            type: 'pie',
                            radius: '55%',
                            center: ['35%', '55%'],
                            data: this.financingByMartialStatusList.map(item=>({
                                name: item.fi__martialStatus,
                                value: item.fi__counts||0
                            })),
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            },
                            itemStyle:{
                                normal:{
                                    label:{
                                        textStyle:{
                                            fontSize:24,
                                            color:'#96dcff'
                                        }
                                    },
                                    labelLine:{
                                        lineStyle:{
                                            color:'#96dcff'
                                        }
                                    }
                                }

                            }
                        }
                    ]

                });
            },
            getFinancingByMartialStatusList: function () {
                xhr.getFinancingByMartialStatusList(0, ({data}) => {
                    if (data.status === 'success') {
                        const financingByMartialStatusList = data.data||[]

                        financingByMartialStatusList.forEach(item=> {
                            item.fi__martialStatus = item.fi__martialStatus === 'Unknown' ? '未知' : item.fi__martialStatus
                        })
                        this.financingByMartialStatusList = financingByMartialStatusList

                        this.echart04()
                    }
                })
            }
        },
        components: {

        },
        props: {

        },
        beforeDestroy() {
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorEchartsFour.vue